import { useEffect } from "react";
import { useLocation } from "react-router-dom";
/**
 * The URL the providers have been told about, seeded with the one the
 * document loaded on: that is a fact about the page rather than about this
 * component, so it has to survive a remount of the router.
 */
let reportedUrl = window.location.href;
/**
 * Reports client-side route changes to analytics, for the providers that key
 * off page loads. Mount once inside the router; it renders nothing.
 *
 * The mobile webshop is one document for the whole session, so VWO's
 * SmartCode qualifies its campaigns exactly once. Leaving a page and coming
 * back mounts fresh nodes the variation was never applied to, and its changes
 * are simply gone - VwoProvider.onVirtualPageView is what puts them back.
 */
export default function VirtualPageView() {
    const { pathname } = useLocation();
    // Deliberately keyed on the path alone. useTemplateFilters rewrites the
    // query string on every filter toggle, and those are in-place updates
    // rather than navigations: counting them as page loads would inflate VWO's
    // page views for no gain, since the campaign already qualified for the
    // path they happen on.
    useEffect(() => {
        if (window.location.href === reportedUrl) {
            return;
        }
        reportedUrl = window.location.href;
        if (window.isEpmsAnalyticsFeatureEnabled && window.epmsAnalytics) {
            // Absolute: VWO matches page-targeting rules against a full URL.
            window.epmsAnalytics.onVirtualPageView(reportedUrl);
        }
    }, [pathname]);
    return null;
}
